
import { AuthService } from "@/services/AuthService";
import { UserAppState } from "@/store";
import { Component, Vue } from "vue-property-decorator";

@Component
class AuthCodeCallback extends Vue {
  authService = new AuthService();
  state: "logging_in" | "failed" = "logging_in";
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params: any = {};
    for (const [key, value] of urlParams.entries()) {
      if (value) {
        params[key.replace("?", "")] = value;
      }
    }
    if (!params.code || !params.state) {
      // this.$buefy.toast.open({
      //   message:
      //     "Login failed, bc mandatory parameters missing. Sending you to home page.",
      //   type: "is-warning"
      // });
      this.$router.push({ name: "home" });
      return;
    }

    // this.authService
    //   .exchangeCodeForToken(params.code, params.state, this.$router)
    //   .subscribe(([tokenResponse, me, permissions]) => {
    //     console.log(tokenResponse);
    //     console.log(me);
    //     if (me.loggedIn && permissions.isSuccessful) {
    //       this.$store.commit("user", {
    //         name: me.account?.fullName,
    //         email: me.account?.email,
    //         avatar: `https://avatars.dicebear.com/v2/initials/${me.account?.fullName.replaceAll(
    //           " ",
    //           "-"
    //         )}.svg`,
    //         id: permissions?.id,
    //         groups: permissions?.groups,
    //         permissions: permissions?.permissions
    //       } as UserAppState);
    //     } else {
    //       this.state = "failed";
    //       console.log("Error: user is not logged in");
    //       this.$store.commit("accessDenied");
    //     }
    //   });
  }
}

export default AuthCodeCallback;
